// import React, { useEffect, useState } from "react";
// import { Row, Button, Card, Col, Modal, message } from "antd";
// import { useOutletContext } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { EyeOutlined } from "@ant-design/icons";
// import DataTable from "../DataTable/DataTable";
// import { getUserData } from "../login/LoginSlice";
// import { getCdStatement } from "../../Action/Actions";

// const CdStatement = () => {
//   const { selectedYear } = useOutletContext();
//   const dispatch = useDispatch();
//   const AuthData = useSelector(getUserData);
//   const [loading, setLoading] = useState(false);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [selectedRecord, setSelectedRecord] = useState(null);
//   const [depositEntries, setDepositEntries] = useState([]);
//   const [premiumEntries, setPremiumEntries] = useState([]);
//   const [totalDeposit, setTotalDeposit] = useState(0);
//   const [totalCredit, setTotalCredit] = useState(0);
//   const [totalDebit, setTotalDebit] = useState(0);
//   const [balanceAmount, setBalanceAmount] = useState(0);
//   const Id = AuthData?.corporate_id;
//   const user = useSelector(getUserData);
//   const [pagination, setPagination] = useState({});

//   useEffect(() => {
//     document.title = `CD Statement`;
//     fetchCdStatement();
//   }, []);


//   const fetchCdStatement = async (corporateId,page = 1) => {
//     try {
//       setLoading(true);
//       console.log(`Fetching CD statement for corporateId: ${Id}`);
//       const data = await dispatch(getCdStatement(AuthData.corporateId,page));
//       if (data) {
//         console.log("CD statement response:", data);
//         const depositEntriesWithKeys = data.Deposite_entry.map((entry, index) => ({
//           ...entry,
//           key: index + 1,
//         }));
//         const premiumEntriesWithKeys = data.Premium_entry.map((entry, index) => ({
//           ...entry,
//           key: index + 1,
//         }));
//         setDepositEntries(depositEntriesWithKeys);
//         setPremiumEntries(premiumEntriesWithKeys);
//         setTotalDeposit(data.Total_Deposite_entry || 0);
//         setTotalCredit(data.Total_credit_amount || 0);
//         setTotalDebit(data.Total_debit_amount || 0);
//         setBalanceAmount(data.Balance_amount || 0);
//         setPagination((prev) => ({
//           ...prev,
//           current: data.Deposite_entry.current_page,
//           total: data.Deposite_entry.total,
//         }));
//       } else {
//         throw new Error("Invalid response data");
//       }
//     } catch (error) {
      
//       console.error("Error fetching CD statement:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const showModal = (record) => {
//     setSelectedRecord(record);
//     setIsModalVisible(true);
//   };

//   const handleModalClose = () => {
//     setIsModalVisible(false);
//     setSelectedRecord(null);
//   };

//   const depositColumns = [
//     {
//       title: "SI NO",
//       dataIndex: "key",
//     },
//     {
//       title: "PARTICULAR",
//       dataIndex: "particular",
//     },
//     {
//       title: "CD NUMBER",
//       dataIndex: "cd_number",
//     },
//     {
//       title: "BANK NAME",
//       dataIndex: "bank_name",
//     },
//     {
//       title: "CHEQUE NUMBER",
//       dataIndex: "cheque_no",
//     },
//     {
//       title: "AMOUNT",
//       dataIndex: "credit_amount",
//       render: (amount) => `₹${amount.toLocaleString()}`,
//     },
//     {
//       title: "CREATED AT",
//       dataIndex: "created_at",
//       render: (date) => new Date(date).toLocaleString(),
//     },
//   ];

//   const premiumColumns = [
//     {
//       title: "SI NO",
//       dataIndex: "key",
//     },
//     {
//       title: "PARTICULAR",
//       dataIndex: "particular",
//     },
//     {
//       title: "POLICY NUMBER",
//       dataIndex: "policy_type",
//     },
//     {
//       title: "CD NUMBER",
//       dataIndex: "cd_number",
//     },
//     {
//       title: "BANK NAME",
//       dataIndex: "bank_name",
//     },
//     {
//       title: "CHEQUE NUMBER",
//       dataIndex: "cheque_no",
//     },
//     {
//       title: "DEBIT AMOUNT (DR)",
//       dataIndex: "debit_amount",
//       render: (amount) => amount ? `₹${amount.toLocaleString()}` : null,
//     },
//     {
//       title: "CREDIT AMOUNT (CR)",
//       dataIndex: "credit_amount",
//       render: (amount) => amount ? `₹${amount.toLocaleString()}` : null,
//     },
//     {
//       title: "TRANSACTION DATE",
//       dataIndex: "transaction_date",
//       render: (date) => new Date(date).toLocaleDateString(),
//     },
//     {
//       title: "ATTACHMENT",
//       dataIndex: "attachment",
//       render: (_, record) => (
//         <Button
//           className="d-flex-table"
//           icon={<EyeOutlined />}
//           onClick={() => showModal(record)}
//           type="button"
//           style={{ background: "#1890ff" }}
//         >
//           View
//         </Button>
//       ),
//     },
//     {
//       title: "CREATED AT",
//       dataIndex: "created_at",
//       render: (date) => new Date(date).toLocaleString(),
//     },
//   ];
//   const handleTableChange = (pagination) => {
//     fetchCdStatement(pagination);
//   };

//   return (
//     <div className="escalation-matrix-container">
//       <div className="escalation-content mb-3">
//         <Row className="escalation-row-header">
//           <span style={{ fontWeight: "700", fontSize: "20px" }}>{user?.fullname || "Guest"}</span>
//           (Financial Year: {selectedYear})
//         </Row>
//       </div>
//       <div>
//         <Card title="Deposit Entry" className="mb-4">
//           <DataTable
//             columns={depositColumns}
//             dataSource={depositEntries}
//             pagination={pagination}
//             onChange={handleTableChange}
//             bordered
//           />
//           <Row>
//             <Col className="col-md-3"></Col>
//             <Col className="col-md-6">
//               <Card className="card-body text-center amt-card">
//                 <p>Total: ₹{totalDeposit.toLocaleString()}</p>
//               </Card>
//             </Col>
//             <Col className="col-md-3"></Col>
//           </Row>
//         </Card>
//         <Card title="Premium Entry" className="mb-4">
//           <DataTable
//             id="claimsTable"
//             columns={premiumColumns}
//             dataSource={premiumEntries}
//             rowKey="claimId"
//             pagination={pagination}
//             onChange={handleTableChange}
//           />
//           <Row>
//             <Col className="col-md-6">
//               <Card className="card-body text-center amt-card">
//                 <p>Total Credit Amount: ₹{totalCredit.toLocaleString()}</p>
//               </Card>
//             </Col>
//             <Col className="col-md-6">
//               <Card className="card-body text-center amt-card">
//                 <p>Total Debit Amount: ₹{totalDebit.toLocaleString()}</p>
//               </Card>
//             </Col>
//           </Row>
//         </Card>
//         <Card>
//           <Row>
//             <Col className="col-md-3"></Col>
//             <Col className="col-md-6">
//               <Card className="card-body text-center amt-card">
//                 <p>Balance Amount: ₹{balanceAmount.toLocaleString()}</p>
//               </Card>
//             </Col>
//             <Col className="col-md-3"></Col>
//           </Row>
//           <Row>
//             <Col className="col-md-2"></Col>
//             <Col className="col-md-8">
//               <Card className="card-body text-center amt-card">
//                 <p>Provisional Balance Amount: ₹{balanceAmount.toLocaleString()}</p>
//               </Card>
//             </Col>
//             <Col className="col-md-2"></Col>
//           </Row>
//         </Card>
//         <Modal
//           title="Family Dependent"
//           open={isModalVisible}
//           onCancel={handleModalClose}
//           footer={null}
//           width={800}
//         >
//           {selectedRecord && (
//             <div>
//               <p>Particular: {selectedRecord.particular}</p>
//               <p>CD Number: {selectedRecord.cd_number}</p>
//               <p>Bank Name: {selectedRecord.bank_name}</p>
//               <p>Cheque Number: {selectedRecord.cheque_no}</p>
//               <p>Amount: ₹{selectedRecord.credit_amount?.toLocaleString()}</p>
//               <p>Created At: {new Date(selectedRecord.created_at).toLocaleString()}</p>
//             </div>
//           )}
//         </Modal>
//       </div>
//     </div>
//   );
// };

// export default CdStatement;

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Row, Button, Card, Col, Modal, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { EyeOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons";
import DataTable from "../DataTable/DataTable";
import { getUserData } from "../login/LoginSlice";
import { getCdStatement, fetchEnrollmentPolicyType } from "../../Action/Actions";
import { selectFinancialYears, selectSelectedYearId } from "../../Redux/financialYearSlice";
import "./cd.css";

const CdStatement = () => {
  const dispatch = useDispatch();
  const user = useSelector(getUserData);
  const selectedYearId = useSelector(selectSelectedYearId);
  const yearList = useSelector(selectFinancialYears);

  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [statementData, setStatementData] = useState({
    depositEntries: [],
    premiumEntries: [],
    totalDeposit: 0,
    totalCredit: 0,
    totalDebit: 0,
    balanceAmount: 0,
  });

  // Policy type / number data (from fetchEnrollmentPolicyType)
  const [policyData, setPolicyData] = useState({});
  const [activePolicyType, setActivePolicyType] = useState(null);
  const [selectedPolicyNumber, setSelectedPolicyNumber] = useState(null);
  const [selectedPolicyId, setSelectedPolicyId] = useState(null);

  // State for separate paginations, as API provides two paginator objects
  const [depositPagination, setDepositPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [premiumPagination, setPremiumPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  // Derive the selected year string using useMemo for efficiency
  const selectedYear = useMemo(() =>
    yearList.find(year => year.id === selectedYearId)?.financial_year || "",
    [yearList, selectedYearId]
  );

  // Fetch available policy types/numbers for the corporate
  const loadPolicyTypes = useCallback(async () => {
    if (!user?.corporate_id || !selectedYearId) {
      setPolicyData({});
      setActivePolicyType(null);
      setSelectedPolicyNumber(null);
      clearData();
      return;
    }
    try {
      const res = await dispatch(fetchEnrollmentPolicyType(user.corporate_id));
      
      const policy_type_list = res?.policy_type_list || {};
      setPolicyData(policy_type_list);
      
      const firstType = Object.keys(policy_type_list || {})[0] || null;
      setActivePolicyType(firstType);
      const firstPolicy = firstType ? policy_type_list[firstType]?.[0] : null;
      
      if (firstPolicy) {
        setSelectedPolicyNumber(firstPolicy?.policy_number || null);
        setSelectedPolicyId(firstPolicy?.policy_id || null);
      } else {
        setSelectedPolicyNumber(null);
        setSelectedPolicyId(null);
        clearData();
      }
    } catch (err) {
      console.error("Error loading policy types:", err);
      setPolicyData({});
      setActivePolicyType(null);
      setSelectedPolicyNumber(null);
      clearData();
    }
  }, [dispatch, user?.corporate_id, selectedYearId]);

  // Clear data function
  const clearData = () => {
    setStatementData({
      depositEntries: [],
      premiumEntries: [],
      totalDeposit: 0,
      totalCredit: 0,
      totalDebit: 0,
      balanceAmount: 0,
    });
    setDepositPagination({ current: 1, pageSize: 10, total: 0 });
    setPremiumPagination({ current: 1, pageSize: 10, total: 0 });
  };

  const fetchCdStatement = useCallback(async (page = 1, policyIdentifier = null) => {
    // policyIdentifier should be a policy_number or policy_id; fallback to currently selected policy number/id
    const identifierToUse = policyIdentifier ?? selectedPolicyNumber ?? selectedPolicyId ?? user?.corporate_id;

    if (!identifierToUse || !user?.corporate_id) {
      clearData();
      return;
    }

    setLoading(true);
    try {
      const data = await dispatch(getCdStatement(identifierToUse, page));

      setStatementData({
        depositEntries: data?.Deposite_entry?.data?.map((d, i) => ({ ...d, key: i })) || [],
        premiumEntries: data?.Premium_entry?.data?.map((p, i) => ({ ...p, key: i })) || [],
        totalDeposit: data?.Total_Deposite_entry || 0,
        totalCredit: data?.Total_credit_amount || 0,
        totalDebit: data?.Total_debit_amount || 0,
        balanceAmount: data?.Balance_amount || 0,
      });

      setDepositPagination({
        current: data?.Deposite_entry?.current_page || 1,
        pageSize: data?.Deposite_entry?.per_page || 10,
        total: data?.Deposite_entry?.total || 0,
      });

      setPremiumPagination({
        current: data?.Premium_entry?.current_page || 1,
        pageSize: data?.Premium_entry?.per_page || 10,
        total: data?.Premium_entry?.total || 0,
      });

    } catch (error) {
      clearData();
      console.error("Error fetching CD statement:", error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, selectedPolicyNumber, selectedPolicyId, user?.corporate_id]);

  // Effect to reset pagination and fetch policy types when user or year changes
  useEffect(() => {
    document.title = "CD Statement";
    // Reset to page 1 and fetch policy types
    setDepositPagination(p => ({ ...p, current: 1 }));
    setPremiumPagination(p => ({ ...p, current: 1 }));
    loadPolicyTypes();
  }, [loadPolicyTypes]); // loadPolicyTypes includes dependencies

  // When selected policy number or ID changes, fetch its CD statement
  useEffect(() => {
    if (selectedPolicyNumber || selectedPolicyId) {
      // Reset pagination and fetch first page for the selected policy
      setDepositPagination(p => ({ ...p, current: 1 }));
      setPremiumPagination(p => ({ ...p, current: 1 }));
      fetchCdStatement(1, selectedPolicyNumber || selectedPolicyId);
    } else {
      clearData();
    }
  }, [selectedPolicyNumber, selectedPolicyId, fetchCdStatement]);

  // Handler for pagination change. Since one API call fetches both, we update the master page and refetch.
  const handleTableChange = (pagination) => {
    fetchCdStatement(pagination.current, selectedPolicyNumber || selectedPolicyId);
  };
  
  // Modal functions
  const showModal = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
  };

  const depositColumns = [
    { title: "SI NO", dataIndex: "key", render: (text, record, index) => (depositPagination.current - 1) * depositPagination.pageSize + index + 1 },
    { title: "PARTICULAR", dataIndex: "particular" },
    { title: "CD NUMBER", dataIndex: "cd_number" },
    { title: "BANK NAME", dataIndex: "bank_name" },
    { title: "CHEQUE NUMBER", dataIndex: "cheque_no" },
    { title: "AMOUNT", dataIndex: "credit_amount", render: (amount) => amount ? `₹${amount.toLocaleString()}` : "N/A" },
    { title: "CREATED AT", dataIndex: "created_at", render: (date) => date ? new Date(date).toLocaleString() : "N/A" },
  ];

  const premiumColumns = [
    { title: "SI NO", dataIndex: "key", render: (text, record, index) => (premiumPagination.current - 1) * premiumPagination.pageSize + index + 1 },
    { title: "PARTICULAR", dataIndex: "particular" },
    { title: "POLICY TYPE", dataIndex: "policy_type" },
    { title: "CD NUMBER", dataIndex: "cd_number" },
    { title: "BANK NAME", dataIndex: "bank_name" },
    { title: "CHEQUE NUMBER", dataIndex: "cheque_no" },
    { title: "DEBIT AMOUNT (DR)", dataIndex: "debit_amount", render: (amount) => amount ? `₹${amount.toLocaleString()}` : "—" },
    { title: "CREDIT AMOUNT (CR)", dataIndex: "credit_amount", render: (amount) => amount ? `₹${amount.toLocaleString()}` : "—" },
    { title: "CREATED AT", dataIndex: "created_at", render: (date) => date ? new Date(date).toLocaleString() : "N/A" },
    { title: "ATTACHMENT", dataIndex: "attachment", render: (_, record) => record?.attachment ? (
      <Button icon={<EyeOutlined />} onClick={() => showModal(record)}>View</Button>
    ) : "—" },
  ];

  return (
    <Spin spinning={loading}>
      <div className="escalation-matrix-container">
        <div className="escalation-content mb-3">
          <Row className="escalation-row-header">
            <span style={{ fontWeight: "700", fontSize: "20px" }}>
              {user?.corporate_name || "Guest"}
            </span>
            <span className="header-year-spacing">
              (Financial Year: {selectedYear})
            </span>
          </Row>

          {/* Policy Type tabs */}
          <Row className="policy-row-spacing policy-tabs-container" gutter={8}>
            {Object.keys(policyData || {}).map((type) => (
              <Col key={type}>
                <Button
                  className={`policy-tab ${type === activePolicyType ? "active" : ""}`}
                  onClick={() => {
                    setActivePolicyType(type);
                    const firstPolicy = policyData[type]?.[0];
                    setSelectedPolicyNumber(firstPolicy?.policy_number || null);
                    setSelectedPolicyId(firstPolicy?.policy_id || null);
                    if (firstPolicy) fetchCdStatement(1, firstPolicy.policy_number || firstPolicy.policy_id);
                  }}
                >
                  {type === 'GMC' ? <TeamOutlined style={{ color: '#0072bb' }} /> : type === 'GPA' ? <UserOutlined style={{ color: '#0072bb' }} /> : null}
                  <span>{type}</span>
                </Button>
              </Col>
            ))}
          </Row>

          {/* Policy numbers list */}
          <Row className="policy-row-spacing" gutter={8}>
            {(() => {
              const list = policyData?.[activePolicyType] || [];
              return list.map((p, idx) => (
                <Col key={p?.policy_id ?? `policy-${idx}`}>
                  <Button
                    className={`${p?.policy_id === selectedPolicyId ? 'policy-number active' : 'policy-number'} ${!p.policy_number ? 'policy-not-issued' : ''}`}
                    onClick={() => {
                      setSelectedPolicyNumber(p.policy_number);
                      setSelectedPolicyId(p.policy_id);
                      fetchCdStatement(1, p.policy_number || p.policy_id);
                    }}
                  >
                    {p.policy_number ? (
                      p.policy_number
                    ) : (
                      <span
                        style={{
                          backgroundColor: "#FFFF00",
                          color: "#000000E0",
                          padding: "2px 8px",
                          fontSize: "12px",
                          fontFamily: '"Plus Jakarta Sans", sans-serif',
                          borderRadius: "4px",
                          display: "inline-block",
                        }}
                      >
                        Policy Number not issued
                      </span>
                    )}
                  </Button>
                </Col>
              ));
            })()}

            {Object.keys(policyData || {}).length === 0 && (
              <Col span={24}>
                <Card>
                  <p>No policy data available for the selected financial year.</p>
                </Card>
              </Col>
            )}
          </Row>
        </div>

        <Card title="Deposit Entry" className="mb-4">
          <DataTable
            columns={depositColumns}
            dataSource={statementData.depositEntries}
            pagination={depositPagination}
            onChange={handleTableChange}
            bordered
          />
          <Row justify="center" className="section-gap">
            <Col xs={24} sm={12} md={8}>
              <Card className="text-center amt-card">
                <strong>Total Deposit: ₹{statementData.totalDeposit.toLocaleString()}</strong>
              </Card>
            </Col>
          </Row>
        </Card>

        <Card title="Premium Entry" className="mb-4">
          <DataTable
            columns={premiumColumns}
            dataSource={statementData.premiumEntries}
            pagination={premiumPagination}
            onChange={handleTableChange}
            bordered
          />
          <Row gutter={[16, 16]} className="section-gap">
            <Col xs={24} md={12}>
              <Card className="text-center amt-card">
                <strong>Total Credit Amount: ₹{statementData.totalCredit.toLocaleString()}</strong>
              </Card>
            </Col>
            <Col xs={24} md={12}>
              <Card className="text-center amt-card">
                <strong>Total Debit Amount: ₹{statementData.totalDebit.toLocaleString()}</strong>
              </Card>
            </Col>
          </Row>
        </Card>

        <Card>
          <Row justify="center" gutter={[16, 16]}>
            <Col xs={24} sm={18} md={12}>
              <Card className="text-center amt-card">
                <h3>Balance Amount: ₹{statementData.balanceAmount.toLocaleString()}</h3>
              </Card>
            </Col>
          </Row>
        </Card>

        <Modal
          title="Attachment Details"
          open={isModalVisible}
          onCancel={handleModalClose}
          footer={[<Button key="back" onClick={handleModalClose}>Close</Button>]}
          width={800}
        >
          {selectedRecord ? (
            <div>
              {/* Render details of the selected record for the modal */}
              <p><strong>Particular:</strong> {selectedRecord.particular || "N/A"}</p>
              <p><strong>Policy Type:</strong> {selectedRecord.policy_type || "N/A"}</p>
              {/* Add other relevant fields from the record */}
            </div>
          ) : <p>No details to display.</p>}
        </Modal>
      </div>
    </Spin>
  );
};

export default CdStatement;
